<div class="button-container">
  <button  title="Закрыть"
           class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div class="navigation-dialog-container">
  <ng-container *ngIf="navMenu$ | async as menu; else spinner">
    <div class="navigation-dialog-header">
      <div *ngIf="iomType$ | async as type" class="navigation-dialog-type inactive-text">{{ type.type }}</div>
      <div class="navigation-dialog-title">{{iomTitle}}</div>
    </div>
    <div class="navigation-dialog-content">
      <ng-container *ngFor="let el of menu">
        <ng-container>
          <div class="navigation-element-l0">
            <div class="navigation-element-l0__container">
              <ng-container *ngIf="el.expandable; else iconPlaceHolder">
                <mat-icon
                  [ngClass]="{'inactive-link': !el.enabled,
                    'inactive-icon': !el.enabled
                  }"
                  (click)="handleExpansionClick(el)"
                  class="primary-icon clickable unshrinkable icon"
                  [svgIcon]="el.expanded ? 'minus' : 'plus'"></mat-icon>
              </ng-container>
                <span (click)="goToElement(el)"
                      [ngClass]="{'inactive-text': !el.enabled}"
                      class="navigation-element-l0__name clickable">{{el.name}}</span>
            </div>
            <div class="expandeble-animated" *ngIf="el.expanded" [@animateOpenCloseSublevel]="el.expanded">
              <div class="sublevel-elements">
                <ng-container *ngTemplateOutlet="navElements; context: {elements: el.elements}"></ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #navElements let-elements="elements">
  <ng-container *ngFor="let element of elements">
    <div class="sublevel-container">
      <div
        class="sublevel-element clickable">
        <ng-container *ngIf="element.expandable; else iconPlaceHolder">
          <mat-icon
            [ngClass]="{'inactive-link': !element.enabled,
                    'inactive-icon': !element.enabled
                  }"
            (click)="handleExpansionClick(element)"
            class="primary-icon clickable unshrinkable icon"
            [svgIcon]="element.expanded ? 'sort-down' : 'sort-up'"></mat-icon>
        </ng-container>
        <div class="sublevel-element__name">
                    <span
                      [ngClass]="{'inactive-text': !element.enabled}"
                      (click)="goToElement(element)">{{element.name}}</span>
        </div>
      </div>
      <div class="expandeble-animated" *ngIf="element.expanded" [@animateOpenCloseSublevel]="element.expanded">
        <div class="sublevel-elements tab">
          <ng-container *ngTemplateOutlet="navElements; context: {elements: element.elements}"></ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #spinner>
  <app-spinner class="custom-spinner"></app-spinner>
</ng-template>

<ng-template #iconPlaceHolder>
  <mat-icon  class="icon-primary icon unshrinkable"></mat-icon>
</ng-template>
